export default "__VITE_ASSET__$MtSgHzl__"